import { apiFetch } from './client';

const BASE_URL = '/api/ai-core';

export type FeedbackSentiment = 'up' | 'down';
export type FeedbackReason = 'incorrect' | 'missing-info' | 'slow' | 'wrong-tool' | 'other';
export type FeedbackTargetKind = 'chat_message' | 'inline_card' | 'insight';
export interface InlineCardTargetRef { pluginId: string; entityType: string; entityId: string; field: 'card'; }
export interface InsightTargetRef { insightId: string; ruleId: string; }

export interface FeedbackDto {
  threadId: string | null;
  messageId: string | null;
  targetKind: FeedbackTargetKind;
  targetRef: InlineCardTargetRef | InsightTargetRef | null;
  sentiment: FeedbackSentiment;
  reasons?: FeedbackReason[];
  freeText?: string;
  snapshot: Record<string, unknown>;
}

export interface FeedbackRow {
  id: string; companyId: string; userId: string;
  threadId: string | null; messageId: string | null;
  targetKind: FeedbackTargetKind; targetRef: InlineCardTargetRef | InsightTargetRef | null;
  sentiment: FeedbackSentiment; reasons: FeedbackReason[];
  freeText: string | null; snapshot: Record<string, unknown>;
  createdAt: string;
}

export const submitFeedback = async (dto: FeedbackDto): Promise<FeedbackRow> =>
  apiFetch<FeedbackRow>(`${BASE_URL}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dto),
    credentials: 'include',
  });

export interface MyFeedbackQuery {
  targetKind: FeedbackTargetKind;
  threadId?: string;
  messageId?: string;
  pluginId?: string;
  entityType?: string;
  entityId?: string;
}

export const fetchMyFeedback = async (q: MyFeedbackQuery): Promise<{ feedback: FeedbackRow | null }> => {
  const params: Record<string, string> = { targetKind: q.targetKind };
  if (q.threadId) params.threadId = q.threadId;
  if (q.messageId) params.messageId = q.messageId;
  if (q.pluginId) params.pluginId = q.pluginId;
  if (q.entityType) params.entityType = q.entityType;
  if (q.entityId) params.entityId = q.entityId;
  const qs = new URLSearchParams(params).toString();
  return apiFetch<{ feedback: FeedbackRow | null }>(`${BASE_URL}/feedback?${qs}`, { credentials: 'include' });
};
